export default "__VITE_ASSET__DueYf$C6__"